import ConfigNode from 'Model/ConfigNode'
import { branch } from 'Model/constants'

class TypeSizes extends ConfigNode
  @className = 'TypeSizes'

  constructor: ->
    super('typeSizes')

  map: ->
    @get('value')

  update: (map, params = {}) ->
    @set('value', map, { dataType: 'json' })
    @save(params)

  reset: (params = {}) ->
    @update({}, params)

  @load: ->
    super('typeSizes', @)

export default TypeSizes
